// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tRpJ","content":"styles_content__3ye8V","tableWrap":"styles_tableWrap__17vzn"};